import React from 'react';

import { Box, IconButton } from '@material-ui/core';
import { IoClose } from 'react-icons/io5';

import { Image } from '@vyce/core/src/types';

import useStyles from '../styles';

interface Props {
  photos: Image[];
  onRemove: (index: number) => void;
}

export const PhotoThumbnails = ({ photos, onRemove }: Props) => {
  const classes = useStyles();

  if (!photos.length) return null;

  return (
    <Box className={classes.thumbnailsWrapper}>
      {photos.map((photo, index) => (
        <Box key={photo.url || index} className={classes.thumbnail}>
          <img src={photo.url} alt={photo.name || `photo-${index}`} className={classes.thumbnailImage} />
          <IconButton
            size="small"
            className={classes.removeButton}
            onClick={() => onRemove(index)}
            aria-label="Remove photo"
          >
            <IoClose size="14px" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};
